import { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';
import { CartItem, CartScheduleSlot } from '@/types/cart.types';
import { ProcedureTypeEnum } from '@/types/enums/procedure-type.enum';
import { dateFormatter } from '@/utils/formatters/date';

export const BRASILIA_TIME_LABEL = '(horário de Brasília)';
export const ARRIVAL_ORDER_LABEL = 'por ordem de chegada';

const WINDOWED_SCHEDULE_TYPES: ReadonlySet<string> = new Set([
  ScheduleType.ARRIVAL_ORDER,
  ScheduleType.LABORATORIAL,
]);

function isValidSlotDate(value?: string | null): value is string {
  return !!value && !Number.isNaN(new Date(value).getTime());
}

export function formatCartItemSchedule(slot: CartScheduleSlot): string {
  if (!isValidSlotDate(slot.start)) {
    return '';
  }

  const formatted = dateFormatter(slot.start, 'DD/MM/YYYY [às] HH:mm');

  if (!formatted) {
    return '';
  }

  return `${formatted} ${BRASILIA_TIME_LABEL}`;
}

export function formatCartArrivalOrderSchedule(slot: CartScheduleSlot): string {
  if (!isValidSlotDate(slot.start)) {
    return '';
  }

  const date = dateFormatter(slot.start, 'date');
  const start = dateFormatter(slot.start, 'HH:mm');

  if (!date || !start) {
    return '';
  }

  if (!isValidSlotDate(slot.end)) {
    return `${date} às ${start} ${BRASILIA_TIME_LABEL}, ${ARRIVAL_ORDER_LABEL}`;
  }

  const end = dateFormatter(slot.end, 'HH:mm');

  return `${date}, das ${start} às ${end} ${BRASILIA_TIME_LABEL}, ${ARRIVAL_ORDER_LABEL}`;
}

function isWindowedCartSlot(slot: CartScheduleSlot): boolean {
  return !!slot.scheduleType && WINDOWED_SCHEDULE_TYPES.has(slot.scheduleType);
}

export function formatCartItemScheduleLabel(item: CartItem): string {
  return isWindowedCartSlot(item.slot) || item.procedure.type === ProcedureTypeEnum.LABORATORY
    ? formatCartArrivalOrderSchedule(item.slot)
    : formatCartItemSchedule(item.slot);
}
